import { DisposableGroup } from '@blocksuite/global/utils';
export class BlockService {
    constructor(options) {
        this.disposables = new DisposableGroup();
        this.flavour = options.flavour;
        this.std = options.std;
    }
    get workspace() {
        return this.std.workspace;
    }
    get page() {
        return this.std.page;
    }
    get selectionManager() {
        return this.std.selection;
    }
    get uiEventDispatcher() {
        return this.std.event;
    }
    // life cycle start
    dispose() {
        this.disposables.dispose();
    }
    mounted() {
        // do nothing
    }
    unmounted() {
        // do nothing
    }
    // life cycle end
    // event handlers start
    handleEvent(name, fn, options) {
        this.disposables.add(this.uiEventDispatcher.add(name, fn, {
            flavour: options?.global ? undefined : this.flavour,
        }));
    }
    bindHotKey(keymap, options) {
        this.disposables.add(this.uiEventDispatcher.bindHotkey(keymap, {
            flavour: options?.global ? undefined : this.flavour,
        }));
    }
}
//# sourceMappingURL=index.js.map